import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const servicesStartRequest = () => {
  return {
    type: 'SERVICES_START_REQUEST'
  };
};

export const servicesEndRequest = () => {
  return {
    type: 'SERVICES_END_REQUEST'
  };
};

export const getAllServicesSuccess = ({ data }) => {
  return {
    type: 'SERVICES_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllServicesError = error => {
  return {
    type: 'SERVICES_GET_ALL_ERROR',
    payload: error
  };
};

export const addServicesSuccess = ({ data }) => {
  return {
    type: 'SERVICES_ADD_SUCCESS',
    payload: data
  };
};

export const addServicesError = error => {
  return {
    type: 'SERVICES_ADD_ERROR',
    payload: error
  };
};

export const editServicesSuccess = ({ data }) => {
  return {
    type: 'SERVICES_EDIT_SUCCESS',
    payload: data
  };
};

export const editServicesError = error => {
  return {
    type: 'SERVICES_EDIT_ERROR',
    payload: error
  };
};

export const removeServicesSuccess = id => {
  return {
    type: 'SERVICES_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeServicesError = error => {
  return {
    type: 'SERVICES_REMOVE_ERROR',
    payload: error
  };
};

export const servicesModifyStore = ({ data }) => {
  return {
    type: 'SERVICES_MODIFY_STORE',
    payload: data
  };
};

export const addServices = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(servicesStartRequest());
      const response = await api().post('/api/services', data);
      dispatch(addServicesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'services',
        data: [response.data],
        company: response.data.company
      });
      formReset();
    } catch (err) {
      dispatch(addServicesError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(servicesEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllServices = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(servicesStartRequest());
      const response = await api().get('/api/services', { params });
      dispatch(getAllServicesSuccess(response));
    } catch (err) {
      dispatch(getAllServicesError(err));
    } finally {
      dispatch(servicesEndRequest());
    }
  };
};

export const editServices = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(servicesEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(servicesStartRequest());
      const id = data._id;
      const response = await api().put('/api/services/' + id, data);
      dispatch(editServicesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'services',
        data: [response.data],
        company: response.data.company
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/services'));
      }
    } catch (err) {
      dispatch(editServicesError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeServices = id => {
  return async dispatch => {
    try {
      dispatch(servicesStartRequest());
      await api().delete('/api/services/' + id);
      dispatch(removeServicesSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'services',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Serviço removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeServicesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover serviço.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(servicesEndRequest());
    }
  };
};

export const restoreServices = data => {
  return async dispatch => {
    try {
      dispatch(servicesStartRequest());
      const id = data._id;
      const response = await api().put('/api/services/' + id, data);
      dispatch(editServicesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'services',
        data: [response.data],
        company: response.data.company
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Serviço restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editServicesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar serviço.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(servicesEndRequest());
    }
  };
};
